import { render, staticRenderFns } from "./SectionCallToAction.vue?vue&type=template&id=65afb17e&scoped=true&"
import script from "./SectionCallToAction.vue?vue&type=script&lang=js&"
export * from "./SectionCallToAction.vue?vue&type=script&lang=js&"
import style0 from "./SectionCallToAction.vue?vue&type=style&index=0&id=65afb17e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65afb17e",
  null
  
)

export default component.exports